//import React from "react";
import React from 'react';

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons
import WarningIcon from '@material-ui/icons/Warning';

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";

import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
const useStyles = makeStyles(styles);

export default function AccessDenied() {
    const classes = useStyles();    
    return (
        <div className="maxContent no-print">             
        <GridContainer>
           
            <GridItem xs={12} sm={12} md={12}>
            <Card>
            <CardBody>    
               <br/><br/>
               <center>
                  <div style={{width:'80px',height:'80px',textAlign:'center',borderRadius:'50%', lineHeight:'80px',verticalAlign:'middle',color:'red'}}>
                  <WarningIcon style={{fontSize:'45px'}} className={classes.icoBoxEnd}></WarningIcon>
                  </div>
                  <h3>Acesso Negado!</h3>
                  <h5>Entre em contato com o Administrador do sistema!</h5>               
                </center>              
            </CardBody>
            </Card>  
            </GridItem>            
        </GridContainer>
    </div>
    );
}
